import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared.module';
import { materialModules } from '../../../angular-material.module';
import { BaseInputComponent } from './base-input/base-input.component';
import { GroupInputComponent } from './group-input/group-input.component';
import { SelectInputComponent } from './select-input/select-input.component';
import { TextInputComponent } from './text-input/text-input.component';
import { InputComponent } from './input/input.component';
import { ToggleInputComponent } from './toggle-input/toggle-input.component';
import { TextareaInputComponent } from './textarea-input/textarea-input.component';
import { JsonInputComponent } from './json-input/json-input.component';
import { MultiselectInputComponent } from './multiselect-input/multiselect-input.component';
import { RequireSelectionDirective } from './multiselect-input/require-selection.directive';
import { RangeInputComponent } from './range-input/range-input.component';
import { MultiAddInputComponent } from './multi-add-input/multi-add-input.component';
import {SharedDirectiveModule} from "../../directives/shared-directive.module";
import { SetLocaleEditButtonComponent } from './set-locale-edit-button/set-locale-edit-button.component';
import { SharedPipeModule } from "../../pipes/shared-pipe.module";
import { DynamicJsonFormComponent } from './dynamic-json-form/dynamic-json-form.component';
import { MonacoEditorModule, NgxMonacoEditorConfig } from 'ngx-monaco-editor-v2';
import { MonacoInputComponent } from './monaco-input/monaco-input.component';
import { CSSUnitValueInputComponent } from './css-unit-value-input/css-unit-value-input.component';
import { WysiwygInputComponent } from './wysiwyg-input/wysiwyg-input.component';
import { QuillModule } from 'ngx-quill';
import { MergeTagInputComponent } from "./merge-tag-input/merge-tag-input.component";
import { TextChipInputComponent } from "./merge-tag-input/text-chip-input/text-chip-input.component";
import { A11yModule } from "@angular/cdk/a11y";
import { InternationalPhoneInputComponent } from './international-phone-input/international-phone-input.component';
import { ColorPickerDirective } from "ngx-color-picker";
import { WritingToolsComponent } from '../writing-tools/writing-tools.component';
import { TreeViewInputComponent } from './tree-view-input/tree-view-input.component';
import { FontSizeInputComponent } from './wysiwyg-input/modules/font-size-input.component';
import { CodeEditorDialogComponent } from './code-editor-dialog/code-editor-dialog.component';
import { MergeTagPickerModule } from '../merge-tag-picker/merge-tag-picker.module';
import { TippyDirective } from '@ngneat/helipopper';
import { AiCodeSuggestionsComponent } from '../../ai/ai-code-suggestions/ai-code-suggestions.component';
import { BrandKitColorPickerComponent } from '../brand-kit-color-picker/brand-kit-color-picker.component';

const monacoConfig: NgxMonacoEditorConfig = {
	requireConfig: {
		entry: {
			'editor.worker': 'monaco-editor/esm/vs/editor/editor.worker.js',
		}
        } // allows overriding configuration passed to Monaco's loader
};

@NgModule({
	declarations: [
		BaseInputComponent,
		GroupInputComponent,
		SelectInputComponent,
		TextInputComponent,
 		InputComponent,
   		ToggleInputComponent,
		TextareaInputComponent,
 		JsonInputComponent,
     	MultiselectInputComponent,
	 	RequireSelectionDirective,
   		RangeInputComponent,
     	MultiAddInputComponent,
		SetLocaleEditButtonComponent,
		DynamicJsonFormComponent,
		MonacoInputComponent,
		CSSUnitValueInputComponent,
		WysiwygInputComponent,
		MergeTagInputComponent,
		TextChipInputComponent,
		InternationalPhoneInputComponent,
		TreeViewInputComponent,
		FontSizeInputComponent,
		CodeEditorDialogComponent
	],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        SharedDirectiveModule,
        SharedPipeModule,
        MonacoEditorModule.forRoot(monacoConfig),
        QuillModule.forRoot(),
        ...materialModules,
        A11yModule,
		ColorPickerDirective,
		WritingToolsComponent,
		MergeTagPickerModule,
		TippyDirective,
		AiCodeSuggestionsComponent,
		BrandKitColorPickerComponent
    ],
	providers: [],
	exports: [
		GroupInputComponent,
		SelectInputComponent,
		TextInputComponent,
		ToggleInputComponent,
		InputComponent,
		TextareaInputComponent,
		JsonInputComponent,
		MultiselectInputComponent,
		RangeInputComponent,
		MultiAddInputComponent,
		SetLocaleEditButtonComponent,
		DynamicJsonFormComponent,
		MonacoInputComponent,
		CSSUnitValueInputComponent,
		SharedPipeModule,
		WysiwygInputComponent,
		MergeTagInputComponent,
		TextChipInputComponent,
		InternationalPhoneInputComponent,
		TreeViewInputComponent,
		CodeEditorDialogComponent
	]
})
export class InputModule {}
